import React from "react";


const charges = [
    { sno: 1, procedure: "Consultation Charge", amount: "600.00" },
    { sno: 2, procedure: "Cannulation Charge", amount: "300.00" },
    { sno: 3, procedure: "I'M Injection Charge", amount: "200.00" },
    { sno: 4, procedure: "I'V Injection Charge", amount: "200.00" },
    { sno: 5, procedure: "Subcutaneous Charge", amount: "200.00" },
    { sno: 6, procedure: "Care Charge for an Hour", amount: "500.00" },
    { sno: 7, procedure: "RBS Check", amount: "100.00" },
    { sno: 8, procedure: "Large Dressing Procedure", amount: "1000.00" },
    { sno: 9, procedure: "Medium Dressing Procedure", amount: "800.00" },
    { sno: 10, procedure: "Small Dressing Procedure", amount: "500.00" },
    { sno: 11, procedure: "Large Suture Procedure (10×15 cm)", amount: "1200.00" },
    { sno: 12, procedure: "Medium Suture Procedure (5×10 cm)", amount: "1000.00" },
    { sno: 13, procedure: "Small Suture Procedure (1×5 cm)", amount: "800.00" },
    { sno: 14, procedure: "Medical Certificate", amount: "700.00" },
    { sno: 15, procedure: "Fitness Certificate", amount: "700.00" },
    { sno: 16, procedure: "ECG (Electrocardiography)", amount: "500.00" },
    { sno: 17, procedure: "Catheterization Procedure", amount: "1000.00" },
    { sno: 18, procedure: "NPA Procedure", amount: "500.00" },
    { sno: 19, procedure: "OPA Procedure", amount: "500.00" },
    { sno: 20, procedure: "Intubation Procedure", amount: "1000.00" },
    { sno: 21, procedure: "CVC Procedure", amount: "1000.00" },
    { sno: 22, procedure: "Oxygen Charges (1 Hour)", amount: "100.00" },
    { sno: 23, procedure: "Nebulization (1 Hour)", amount: "200.00" }
];

const headerStyle = {
    backgroundColor: "#ec1c24",
    color: "white",
};

const cell = {
    padding: "8px",
    border: "1px solid #ccc",
};

const OurPrice = () => {
    return (
        <div style={{ padding: "41px", backgroundColor: "white" }}>
            <h2 style={{ textAlign: "center", color: "#262262", fontSize: "28px", fontWeight: "bold", }}> Our Service Charges</h2>

            <table
                style={{ width: "100%", borderCollapse: "collapse", border: "black", }}>

                <thead>
                    <tr style={headerStyle}>
                        <th style={cell}>S.No</th>
                        <th style={cell}>Procedure Name</th>
                        <th style={cell}>Charges (₹)</th>
                    </tr>
                </thead>

                <tbody>
                    {charges.map((item) => (<tr key={item.sno}>
                        <td style={cell}>{item.sno}</td>
                        <td style={cell}>{item.procedure}</td>
                        <td style={cell}>{item.amount}</td>
                    </tr>
                    ))}
                </tbody>

            </table>
        </div>
    );
};




export default OurPrice;
